import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import isObject from "lodash/isObject";
import { useTranslation } from "next-i18next";
import React from "react";

import {
  ConfigParamValueWithModifiers,
  getModifiedConfigParamValue,
  ImmigramFormElementConfigBase,
  ImmigramFormElementType,
} from "./common";

export interface ImmigramFormElementConfigParagraph
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Paragraph;
  content: ConfigParamValueWithModifiers;
}

interface ImmigramFormParagraphProps {
  elementConfig: ImmigramFormElementConfigParagraph;
}

function ImmigramFormParagraph({ elementConfig }: ImmigramFormParagraphProps) {
  const { t } = useTranslation();

  let result = null;
  if (isObject(elementConfig)) {
    result = getModifiedConfigParamValue(t, elementConfig.content);
  } else {
    result = elementConfig;
  }

  return <Paragraph className="my-0">{result}</Paragraph>;
}

export { ImmigramFormParagraph };
